export default {
  getExperimentOptions: jest.fn(),
};
